import PropTypes from 'prop-types';
import CategoryItem from './CategoryItem';

const CategoriesList = ({ categories }) => (
  <div className="flex flex-wrap items-center gap-3 mb-6">
    {categories.map((category) => <CategoryItem key={category} category={category} />)}
  </div>
);

CategoriesList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CategoriesList;
